const CheckMarkLinear = ({
  stopColor = '#F82E52',
  stopColorOffset = '#A256BC',
}: {
  stopColor?: string;
  stopColorOffset?: string;
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0458 3.4856C14.3299 3.78703 14.3158 4.26169 14.0144 4.54579L6.08456 12.0197C5.74829 12.3366 5.22042 12.3269 4.89609 11.9977L2.21576 9.27737C1.92504 8.98231 1.92856 8.50745 2.22361 8.21674C2.51867 7.92602 2.99353 7.92954 3.28424 8.22459L5.51839 10.4921L12.9856 3.45421C13.287 3.17011 13.7617 3.18416 14.0458 3.4856Z"
        fill="#1A1A1A"
      />
      <path
        d="M14.0458 3.4856C14.3299 3.78703 14.3158 4.26169 14.0144 4.54579L6.08456 12.0197C5.74829 12.3366 5.22042 12.3269 4.89609 11.9977L2.21576 9.27737C1.92504 8.98231 1.92856 8.50745 2.22361 8.21674C2.51867 7.92602 2.99353 7.92954 3.28424 8.22459L5.51839 10.4921L12.9856 3.45421C13.287 3.17011 13.7617 3.18416 14.0458 3.4856Z"
        fill="url(#paint0_linear_739_12765)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_739_12765"
          x1="2"
          y1="3.25"
          x2="10.1964"
          y2="0.43757"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={stopColor} />
          <stop offset="1" stopColor={stopColorOffset} />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default CheckMarkLinear;
